import React from 'react';

function Bar(props) {
	return <div className={`bar-component ${props.className ?? ''}`.trim()}>{props.children}</div>;
}

export default Bar;
